import FeatureBlock from "./custom/FeatureBlock";
import FeatureBlockData from "./custom/data/FeatureBlockData";

function WhyChooseUs() {
  return (
    <section className="feature-section mb-5">
      <div className="auto-container">
        <div className="sec-title mb_70 centred">
          <h6>Why US</h6>
          <h2>Why Choose Us</h2>
        </div>
        <div
          className="inner-container clearfix wow fadeInLeft animated"
          data-wow-delay="00ms"
          data-wow-duration="1500ms"
        >
          <div className="feature-container">
            {FeatureBlockData.map((feature, index) => (
              <FeatureBlock
                key={index}
                icon={feature.icon}
                title={feature.title}
                description={feature.description}
              />
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}
export default WhyChooseUs;
